import React from 'react';
import {useTranslation} from 'react-i18next';
import {inAnteprima} from '../../skin';

/**
 * Una riga di spiegazione dentro la pagina.
 *
 * Serve a dire COSA FA un blocco, COSA NON FA, e - per i pezzi disegnati ma
 * non ancora collegati - PERCHE' e DOVE si sistemera'. Sta nella pagina e
 * non in un documento a parte, cosi' chi guarda la maschera lo legge li'.
 *
 * tono: 'spento' (da collegare, arancione), 'errore' (rosso), o niente.
 * etichetta: la parola in testa a una nota spenta quando «da collegare» non
 * e' quella giusta (un'immagine non e' da collegare: e' «da caricare»).
 * Chi la passa la passa gia' tradotta.
 *
 * AI GIOCATORI NON SI PARLA DEL BACKOFFICE. Una nota spenta spiega a chi
 * compone la skin cosa manca e dove si sistema: si legge nell'anteprima del
 * backoffice (?anteprima=1). Sul sito vero, a chi gioca, quelle frasi
 * sembravano errori: al loro posto c'e' `giocatore`, una frase scritta per
 * lui (gia' tradotta), o niente.
 */
export default function Nota({tono, piccola, etichetta, giocatore, children}) {
  const {t} = useTranslation();
  if (tono === 'spento' && !inAnteprima()) {
    return giocatore ? <p className={'vet-nota' + (piccola ? ' piccola' : '')}>{giocatore}</p> : null;
  }
  return (
    <p className={'vet-nota' + (tono ? ' ' + tono : '') + (piccola ? ' piccola' : '')}
      role={tono === 'errore' ? 'alert' : undefined}>
      {tono === 'spento' && <span className={'vet-etichetta'}>{etichetta || t('da collegare')}</span>}
      {children}
    </p>
  );
}
